import { memo, useState } from "react";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import Form from "react-bootstrap/Form";
import { useHistory } from "react-router-dom";
import UnSelectTik from "Assets/SvgIcons/UnSelectTik";
import SelectTik from "Assets/SvgIcons/SelectTik";
import LocalStoragekeys from "Constants/LocalStoragekeys";

import { setSignIn } from "Redux/Actions/AuthActions";

import "./styles.scss";
import API from "Constants/Apis";
import Colors from "Constants/Colors";

const Page = () => {
  document.title = "داپ اَپ ؛ ورود";
  const PhoneSearchParam = localStorage.getItem(
    LocalStoragekeys.PhoneSearchParams
  );
  const [termsAccepted, setTermsAccepted] = useState(true);
  const [phoneNumber, setPhoneNumber] = useState(
    PhoneSearchParam ? PhoneSearchParam : ""
  );
  const history = useHistory();
  const dispatch = useDispatch();

  const onClickSubmit = () => {
    if (!phoneNumber || phoneNumber.length < 11) {
      toast("شماره موبایل الزامی است", { type: "error" });
    } else if (phoneNumber && !termsAccepted) {
      toast("لطفا تیک تایید را بزنید.", { type: "warning" });
    } else {
      dispatch(setSignIn(phoneNumber)).then((status) => {});

      history.push({
        pathname: "/otp",
        state: phoneNumber,
      });
      // remove value phone number (PhoneSearchParam)
      localStorage.removeItem(LocalStoragekeys.PhoneSearchParams);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      onClickSubmit();
    }
  };

  return (
    <div className="sigin-screen " style={{ height: window.innerHeight }}>
      <p className="sigin-screen-inter-phone-text">
        شماره موبایل خود را وارد کنید
      </p>
      <Form.Group controlId="sigin-screen-input" className="sigin-screen-form">
        <Form.Control
          type="tel"
          placeholder="مثال: 09xxxxxxxxx"
          className="sigin-screen-input"
          maxLength="11"
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value)}
          onKeyPress={(e) => handleKeyPress(e)}
          // onKeyUp={inputOnKeyUpHandle}
        />
      </Form.Group>
      <div className="sigin-screen-form d-flex flex-row">
        <button
          className="bg-transparent border-0 "
          onClick={() => setTermsAccepted(!termsAccepted)}
        >
          {termsAccepted ? <SelectTik /> : <UnSelectTik fill={Colors.gray1} />}
        </button>
        <p className="sigin-screen-rules-text me-1 mt-3">
          من{" "}
          <a
            href="https://api.daapapp.com/api/v1/policy"
            target="_blank"
            className="text-primary"
          >
            قوانین و شرایط
          </a>{" "}
          را خواندم و آن را می پذیرم
        </p>
      </div>
      <button
        className="sigin-screen-btn bg-dap-success
      "
        onClick={onClickSubmit}
      >
        ادامه
      </button>
    </div>
  );
};
export default memo(Page);
